// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__9Qis8","spin":"styles_spin__ZSuDh"};